/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { DirectDebitMandate } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get direct debit mandates for an account.
 */
export const getAccountDirectDebitMandates = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<DirectDebitMandate[]>>,
) => {
  return backofficeRequest<DirectDebitMandate[]>(
    {
      url: `/api/v1/accounts/${billingAccountId}/direct_debit_mandates`,
      method: "GET",
    },
    options,
  )
}
export type GetAccountDirectDebitMandatesResult = NonNullable<
  Awaited<ReturnType<typeof getAccountDirectDebitMandates>>
>
